import gql from 'graphql-tag';

export const HIDE_RV_PRODUCT = gql`
  mutation HideRVProduct($rvProductId: ID!, $hidden: Boolean!) {
    hideRVProduct(rvProductId: $rvProductId, hidden: $hidden) {
      success
      error
    }
  }
`;
